import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials',
})
export class InitialsPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    const words = value.trim().split(/\s+/);
    const initials = words.map((word) => word[0].toUpperCase());

    return (initials[0] || '') + (initials[1] || '');
  }
}
